import { render, staticRenderFns } from "./LightingPopup.vue?vue&type=template&id=7c3b1879&scoped=true"
import script from "./LightingPopup.vue?vue&type=script&lang=js"
export * from "./LightingPopup.vue?vue&type=script&lang=js"
import style0 from "./LightingPopup.vue?vue&type=style&index=0&id=7c3b1879&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3b1879",
  null
  
)

export default component.exports